module.exports = __webpack_public_path__ + "img/move06.cda180f3.jpg";